import React from 'react';

interface StockOutDialogProps {
  onClose: () => void;
}

const StockOutDialog: React.FC<StockOutDialogProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white dark:bg-gray-800 bg-opacity-20 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">Stock Out</h2>
              <p className="text-red-100 text-sm">Remove inventory for sales or transfers</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white dark:bg-gray-800 hover:bg-opacity-20 rounded-full p-2 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">Stock Out Form</h3>
            <p className="text-gray-500 dark:text-gray-400 mb-6">
              This is a scaffold dialog. The actual form fields will be implemented here.
            </p>
            <div className="bg-gray-50 rounded-lg p-4 text-left text-sm text-gray-600 dark:text-gray-400">
              <p className="font-medium mb-2">Planned fields:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Part code selection</li>
                <li>Quantity</li>
                <li>Destination (Sales Order / Transfer / Scrap)</li>
                <li>Reference number</li>
                <li>Date</li>
                <li>Reason / Notes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            disabled
            className="px-4 py-2 text-white bg-red-500 rounded-lg opacity-50 cursor-not-allowed"
          >
            Remove Stock
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockOutDialog;
